import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

function Bill() {
  const [projects, setBill] = useState([]);
  const { query } = useParams();
  const [sum, setSum] = useState([]);

  const datum = query.split("-");

  useEffect(() => {
    axios
      .get("https://dealersonly.parts/beta/api/user/products?query=" + query)
      .then((res) => {
        setBill(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    let totalArray = [];
    projects[1]?.forEach((project) => {
      let fee, feeString, total;

      switch (project.selector) {
        case "parts":
          // fee = 0.05;
          // feeString = "5%";
          fee = 0;
          feeString = "KOSTENLOS";
          total = formatter.format(project.price * fee);
          totalArray.push(project.price * fee);
          break;
        case "bikes":
          // fee = 50.0;
          // feeString = "50,00€";
          fee = 0;
          feeString = "KOSTENLOS";
          total = formatter.format(fee);
          totalArray.push(fee);

          break;
        case "suchanfragen":
          // fee = 8.9;
          // feeString = "8,90€";
          fee = 0;
          feeString = "KOSTENLOS";
          total = formatter.format(fee);
          totalArray.push(fee);

          break;
        default:
          // fee = 0.05;
          // feeString = "5%";
          fee = 0;
          feeString = "KOSTENLOS";
          total = formatter.format(project.price * fee);
          totalArray.push(project.price * fee);

          break;
      }
    });

    const summe = totalArray.reduce((partialSum, a) => partialSum + a, 0);
    setSum(summe);
  }, [projects]);

  const formatter = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  });

  return (
    <div className="px-4 sm:px-6 lg:px-8 .print-content">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-xl font-semibold text-gray-900">Abrechnung</h1>
          <p className="mt-2 text-sm text-gray-700">
            Gebühren für eingestellte Artikel im Zeitraum{" "}
            <time dateTime="2022-08-01">
              {datum[0].charAt(0).toUpperCase()}
              {datum[0].slice(1)} {datum[1]}
            </time>
            .
          </p>
        </div>
        <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
          <button
            onClick={() => window.print()}
            type="button"
            className="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto print-hidden"
          >
            Drucken
          </button>
        </div>
      </div>
      <div className="-mx-4 mt-8 flex flex-col sm:-mx-6 md:mx-0">
        <table className="min-w-full divide-y divide-gray-300">
          <thead>
            <tr>
              <th
                scope="col"
                className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 md:pl-0"
              >
                Artikel
              </th>
              <th
                scope="col"
                className="hidden py-3.5 px-3 text-right text-sm font-semibold text-gray-900 sm:table-cell"
              >
                Artikelpreis
              </th>
              <th
                scope="col"
                className="hidden py-3.5 px-3 text-right text-sm font-semibold text-gray-900 sm:table-cell"
              >
                Gebühr
              </th>
              <th
                scope="col"
                className="py-3.5 pl-3 pr-4 text-right text-sm font-semibold text-gray-900 sm:pr-6 md:pr-0"
              >
                Gebühr
              </th>
            </tr>
          </thead>
          <tbody>
            {projects[1]?.length !== 0 &&
              projects[1]?.map((project) => {
                let fee, feeString, total;

                switch (project.selector) {
                  case "parts":
                    // fee = 0.05;
                    // feeString = "5%"
                    fee = 0;
                    feeString = "KOSTENLOS";
                    total = formatter.format(project.price * fee);
                    break;
                  case "bikes":
                    // fee = 50.00;
                    // feeString = "50,00€"
                    fee = 0;
                    feeString = "KOSTENLOS";
                    total = formatter.format(fee);
                    break;
                  case "suchanfragen":
                    // fee = 8.90;
                    // feeString = "8,90€"
                    fee = 0;
                    feeString = "KOSTENLOS";
                    total = formatter.format(fee);
                    break;
                  default:
                    // fee = 0.05;
                    // feeString = "5%"
                    fee = 0;
                    feeString = "KOSTENLOS";
                    total = formatter.format(project.price * fee);

                    break;
                }

                return (
                  <tr key={project.id} className="border-b border-gray-200">
                    <td className="py-4 pl-4 pr-3 text-sm sm:pl-6 md:pl-0">
                      <div className="font-medium text-gray-900">
                        {project.title}
                      </div>
                    </td>
                    <td className="hidden py-4 px-3 text-right text-sm text-gray-500 sm:table-cell">
                      {formatter.format(project.price)}
                    </td>
                    <td className="hidden py-4 px-3 text-right text-sm text-gray-500 sm:table-cell">
                      {feeString}
                    </td>
                    <td className="py-4 pl-3 pr-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                      {total}
                    </td>
                  </tr>
                );
              })}
          </tbody>
          <tfoot>
            <tr>
              <th
                scope="row"
                colSpan={3}
                className="hidden pl-6 pr-3 pt-6 text-right text-sm font-normal text-gray-500 sm:table-cell md:pl-0"
              >
                Zwischensumme
              </th>
              <th
                scope="row"
                className="pl-4 pr-3 pt-6 text-left text-sm font-normal text-gray-500 sm:hidden"
              >
                Zwischensumme
              </th>
              <td className="pl-3 pr-4 pt-6 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                {formatter.format(sum)}
              </td>
            </tr>
            <tr>
              <th
                scope="row"
                colSpan={3}
                className="hidden pl-6 pr-3 pt-4 text-right text-sm font-normal text-gray-500 sm:table-cell md:pl-0"
              >
                19% Mwst.
              </th>
              <th
                scope="row"
                className="pl-4 pr-3 pt-4 text-left text-sm font-normal text-gray-500 sm:hidden"
              >
                19 Mwst.
              </th>
              <td className="pl-3 pr-4 pt-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                {formatter.format(sum * 1.19 - sum)}
              </td>
            </tr>
            <tr>
              <th
                scope="row"
                colSpan={3}
                className="hidden pl-6 pr-3 pt-4 text-right text-sm font-semibold text-gray-900 sm:table-cell md:pl-0"
              >
                Total
              </th>
              <th
                scope="row"
                className="pl-4 pr-3 pt-4 text-left text-sm font-semibold text-gray-900 sm:hidden"
              >
                Total
              </th>
              <td className="pl-3 pr-4 pt-4 text-right text-sm font-semibold text-gray-900 sm:pr-6 md:pr-0">
                {formatter.format(sum * 1.19)}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
}

export default Bill;
